module.exports = __webpack_public_path__ + "static/media/entity-quickstart_export-templates.17ded7c5.png";